import { getCmsImagePath } from '../cms/cmsData';

// Helper function to get product image based on item name/type
export const getProductImage = (item) => {
  const name = item.name?.toLowerCase() || '';
  const type = item.type?.toLowerCase() || '';
  
  // Check for vendor booths FIRST (before ticket passes to avoid conflicts)
  if (name.includes('bazaar booth')) {
    return getCmsImagePath('productBazaar', '/product-vendor-bazaar-booth.webp');
  }
  if (name.includes('food truck')) {
    return getCmsImagePath('productFoodTruck', '/product-vendor-food-truck.webp');
  }
  if (name.includes('food booth')) {
    return getCmsImagePath('productFoodBooth', '/product-vendor-food-booth.webp');
  }
  
  // Check for ticket passes (after vendor booths)
  if (name.includes('3-day') || name.includes('3 day')) {
    return getCmsImagePath('product3Day', '/product-3-day.webp');
  }
  if (name.includes('2-day') || name.includes('2 day')) {
    return getCmsImagePath('product2Day', '/product-2-day.webp');
  }
  if (name.includes('1-day') || name.includes('1 day')) {
    return getCmsImagePath('product1Day', '/product-1-day.webp');
  }
  
  // Fallback for other vendor types (legacy support)
  if (name.includes('bazaar') || type.includes('bazaar')) {
    return getCmsImagePath('productBazaar', '/product-vendor-bazaar-booth.webp');
  }
  if (name.includes('food') || type.includes('food')) {
    if (name.includes('truck')) {
      return getCmsImagePath('productFoodTruck', '/product-vendor-food-truck.webp');
    }
    return getCmsImagePath('productFoodBooth', '/product-vendor-food-booth.webp');
  }
  
  // Default fallback
  return getCmsImagePath('logo', '/logo.webp');
};
